export default {
	title: 'Portfolio',
	description: 'Alle meine Gerositus-Projekte',
	actions: {
		back_to_this: 'Zurück zum Portfolio'
	},
	search_projects: 'Projekte suchen',
	cta: {
		welcome: 'Willkommen und danke für Ihre Verbindung zu Gerositus Strategy Suite!',
		subscribe: 'Jetzt abonnieren',
		create_permission: 'um neue Projekte erstellen zu können.'
	},
	tabs: {
		risks: {
			title: 'Einstellungen für Risiken und Chancen'
		}
	}
};
